import { ObjectDataType } from '../DataType';

export const BlobDataType: ObjectDataType = {
    name: 'Blob',
    restriction: 'exact',
    kind: 'object',
    properties: {},
};

export const FileDataType: ObjectDataType = {
    name: 'File',
    restriction: 'exact',
    kind: 'object',
    properties: {
        fileType: { kind: 'string' },
        data: BlobDataType,
    },
};
